
namespace RioERP.Reports {
    export class GstReportSummaryColumns {
        static columnsKey = 'Reports.GstReportSummary';
    }
}